import { v4 as uuidv4 } from 'uuid';
import { PluginProvider } from '../../../system/providers/plugin';
import AnalysisLotGridPluginSettings from './AnalysisLotGridPluginSettings';
import AnalysisLotPluginView from './AnalysisLotPluginView';
import i18n from '../../../i18n';
import { CreateVariant } from '../../MasterTabsProvider';
import { typeReport } from '../DashboardBusinessControls/interfaces';

export const AnalysisLotTab = (variant?: CreateVariant, idGlobal?: string, tabId?: string, contractorName?: string, reportType?: keyof typeof typeReport): ITab => {

    const t = (value: string) => i18n.t("sidePanel." + value);

    const getTabTitle = () => {
        function truncateString(str: string, maxLength: number): string {
            if (!str) return '';
            return str.length > maxLength
                ? `${str.substring(0, maxLength)}...`
                : str;
        }

        if (!reportType) return t("accounting.submenu.analysisLot");

        switch (reportType) {
            case 'Illiquid':
                return `Неликвиды - ${truncateString(contractorName as string, 25)}`;
            case 'Expired':
                return `Просрочка - ${truncateString(contractorName as string, 25)}`;
            case 'ExcessStock':
                return `Излишки - ${truncateString(contractorName as string, 25)}`;
            default:
                return t("accounting.submenu.analysisLot");
        }
    };

    return {
        id: uuidv4(),        
        title: getTabTitle(),
        view: {
            content:    
            AnalysisLotGridPluginSettings
                        ?   <PluginProvider plugin={AnalysisLotGridPluginSettings()}>
                                <AnalysisLotPluginView gridId={uuidv4()} plugin={AnalysisLotGridPluginSettings()} tabId={tabId}/>
                            </PluginProvider>
                        : 
                        <p> Справочник не настроен </p>
        }
    }
}

export default AnalysisLotTab
